// extracted by css-extract-rspack-plugin
export default {"alertMessage":"PricingSection-module__alertMessage__MtBcx","trailingTextSansFeatures":"PricingSection-module__trailingTextSansFeatures__WyHuq"};